// /*  Setting services */
import { request } from "../../Services/Api"

export const getLanguagesList = () => request.api.get(`/user/get-language/`)

export const getNotificationsList = () => request.api.get(`/user/notifications/`)

export const changeNotificationsList = ({ push, email }) =>
  request.api.put(`/user/notifications/`, { push, email })

export const getUserCountry = () => request.api.get(`/user/get_country/`)

export const navToStripe = (return_url) =>
  request.api.get(`/user/stripe_portal/`, {
    return_url: process.env.REACT_APP_BASE_URI + return_url
  })

export const getUsersManagement = async ({ business_account_id }) => {
  if (business_account_id) {
    const res = await request.api.get(
      `/user/business-account/${business_account_id}/list-users-membership/`
    )
    return {
      ...res,
      data: res.data?.results || res.data || []
    }
  }
  return request.api.get(`/user/user-management/available_memberships/`)
}
export const getUsersManagementRoles = () =>
  request.api.get(`/user/user-management/user_management_roles/`)
export const createInviteUserManagement = (data) =>
  request.api.post(`/user/user-management/create_invite_to_business_account/`, data)
export const updateInviteUserManagement = ({ id, ...data }) =>
  request.api.patch(`/user/user-management/${id}/edit_permissions/`, data)
export const resendInviteUserManagement = (id) =>
  request.api.post(`/user/user-management/${id}/resend_invite/`)
export const removeUserManagement = (id) =>
  request.api.delete(`/user/user-management/${id}/remove_invited_user/`)
export const getInviteUserInfo = (inviteId) =>
  request.api.get(`/user/user-management/invitation/${inviteId}/`)
export const rejectInviteUser = (inviteId) =>
  request.api.post(`/user/user-management/invitation/${inviteId}/decline_invite/`)
export const acceptInviteUser = (inviteId) =>
  request.api.post(`/user/user-management/invitation/${inviteId}/accept_invite/`)
export const logoutInviteUser = (inviteId) =>
  request.api.post(`/user/user-management/invitation/${inviteId}/invite_logout/`)
